import React from "react";
import { Modal } from "antd";
import CompleteLicense from "./completeLicense";
import ApplyLicense from "./applyLicense";

function ApplicationModal(props) {
  return (
    <Modal
      open={props.open}
      onCancel={props.close}
      mask={{ enabled: true, blur: false }}
      maskClosable={false} // 대기 중 실수로 닫기 방지
      width="auto"
      centered
      closable={false}
      footer={null}
    >
      {props.status === "complete" ? (
        <CompleteLicense
          product={props.product}
          setStatus={props.setStatus}
          close={props.close}
          refresh={props.refresh}
        />
      ) : (
        <ApplyLicense
          product={props.product}
          setStatus={props.setStatus} // status와 함께 ticketInfo도 전달받음
          close={props.close}
        />
      )}
    </Modal>
  );
}

export default ApplicationModal;